import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const MarketingFooter = () => {
  const navigate = useNavigate();
  return (
    <footer className="mt-24 border-t border-black/5 bg-white">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo />
            <p className="mt-4 text-sm text-ho-muted max-w-[220px] leading-relaxed">
              Build and launch real websites & apps entirely from your phone. No laptop required.
            </p>
          </div>
          <FooterCol
            title="Product"
            items={[
              ["Features", "/features"],
              ["Templates", "/templates"],
              ["Pricing", "/pricing"],
              ["Why phone-first", "/why-phone-first"],
            ]}
          />
          <FooterCol
            title="Resources"
            items={[
              ["Blog", "/blog"],
              ["Contact", "/contact"],
            ]}
          />
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-ho-muted">Get started</h4>
            <button
              onClick={() => navigate("/login")}
              data-testid="footer-cta"
              className="tap-scale mt-4 w-full rounded-full bg-ho-primary text-white px-5 py-3 text-sm font-semibold"
            >
              Start building free
            </button>
          </div>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-black/5 pt-6">
          <p className="text-xs text-ho-muted">© 2026 HandsOn. Built on a phone, for phones.</p>
          <p className="text-xs text-ho-muted">Made with intent · Mobile-first</p>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, items }) => (
  <div>
    <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-ho-muted">{title}</h4>
    <ul className="mt-4 space-y-2.5">
      {items.map(([label, to]) => (
        <li key={to}>
          <Link to={to} className="text-sm text-ho-ink/80 hover:text-ho-primary transition-colors">
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
